/* @flow */

import * as React from 'react';
import styled from 'styled-components';

export type Props = {
  type: string,
  width: number,
  height?: number,
  size?: number,
  color?: string,
  colorHoverd?: String,
  margin?: string,
  bgColor?: string,
  bgColorHoverd?: string,
  border?: string,
  src?: string,
};

const IconWithBG = ({ type, size, color, colorHoverd, src, ...others }: Props) => {
  return (
    <Wrapper {...others}>
      {src ? (
        <img src={src} />
      ) : (
        <Iconfont
          className={`iconfont icon-${type}`}
          size={size}
          color={color}
          colorHoverd={colorHoverd}
        />
      )}
    </Wrapper>
  );
};

IconWithBG.defaultProps = {
  size: 16,
  color: String(),
};

export default IconWithBG;

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  overflow: hidden;
  border: ${({ border }) => border};
  margin: ${({ margin }) => margin};
  width: ${({ width, height }) => `${width || height}px`};
  height: ${({ width, height }) => `${height || width}px`};
  background-color: ${({ bgColor }) => bgColor};
  &:hover {
    background-color: ${({ bgColorHoverd }) => bgColorHoverd};
  }
  > img {
    width: 100%;
    height: 100%;
    outline: none;
  }
`;
const Iconfont = styled.i`
  color: ${({ color }) => color};
  font-size: ${({ size }) => `${size}px`};
  margin: 0 !important;
  &:hover {
    color: ${({ colorHoverd }) => colorHoverd};
  }
`;
